export default __webpack_public_path__ + "static/media/solr-mcp-go.ba92be41.png";